export const approveDocsWarning = 'Please approve documents before awarding bid.';
export const addAwardDocContinue = 'Continue without notifying planholders.';
export const addAwardDocCancel = 'Cancel and let me upload an Award Document.';

/** text on button when the bid is already awarded. */
export const returnToBid = 'Return to Bid';

export const notifyAwardeeTexts = {
  headers: {
    message: 'Message',
    contactInfo: 'Contact Information For Next Steps',
    bidDetails: 'Bid Details',
  },
  labels: {
    subjectLine: 'Subject Line',
    introduction: 'Introduction',
    customMessage: 'Custom Message',
    contactName: 'Contact Name',
    contactEmail: 'Email Address',
    phoneNumber: 'Phone Number',
    jobTitle: 'Job Title',
    agency: 'Agency',
    bidWriter: 'Bid Writer',
    bidNumber: 'Bid Number',
    bidName: 'Bid Name',
    reviewDocs: 'Review Required Documents',
  },
  copy: {
    requiredDocs: [
      'has identified documents you are required to review. There may also be additional documentation you must provide. Please go to the ',
      'Bid Details Page',
      ' for more information.',
    ],
    ifYouHaveQuestions: 'If you have questions, please direct further correspondence to:',
    whatShouldRecipientDo: {
      0: 'What should',
      awardee: 'the awardee',
      nonAwardee: 'the bidder',
      colleague: 'your colleague',
      default: 'the recipient',
      1: 'do next?',
    },
  },
  notificationDefaults: {
    subject: {
      awardees: "You've been awarded a bid on DemandStar.",
      unselected: 'Your bid response was not selected.',
      colleagues: 'A bid has been awarded.',
    },
    introduction: 'Dear',
    customMessage: {
      awardees: 'Congratulations! You have been awarded the following bid.',
      unselected:
        "Thank you so much for responding to our solicitation. We're sorry to inform you that another vendor was chosen. Please keep watching this space for further opportunities.",
      colleagues: 'This bid has been awarded.',
    },
  },
} as const;
